import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import CardBalance from "../../MyAccount/AccountCard/CardBalance";
import useFinalizeManager from "../hooks/useFinalizeManager";
import "./style.scss";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  handleSetPayment: (type: string) => void;
}

const EcardButton: React.FC<IProps> = ({ handleSetPayment }: IProps) => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const isB2B = Boolean(useSelector((state: State) => state.auth.userData.b2bType));
  const { calculateEcard } = useFinalizeManager(() => {});
  const { t } = useTranslation();

  return (
    <>
      {saleConfiguration.ecard_PayByEcard && !isB2B && (
        <>
          <p className="or">{t("lub")}</p>

          <div className="ecard-payment flex-column">
            <EAButton
              title={`${t("zaplac")} ${saleConfiguration.giftCard3Message}`}
              onClick={() => {
                handleSetPayment("ecard");
                calculateEcard();
              }}
              variant="outlined"
              fullWidth
            />
            <b className="bstyling flex-column flex-start">
              {t("dostepne_srodki")}:
              <CardBalance />
            </b>
          </div>
        </>
      )}
    </>
  );
};

export default EcardButton;
